import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class VisionStepPerimeterKey extends BasicEntity {
inc: boolean | null;
key: string;
keyKind: string;
perimeterCode: string;
visionCode: string;
}

